const React = require("react");
const { ThemeProvider } = require("@mui/material/styles");
const theme = require("./src/theme").default;

/**
 * One theme at the root of both the browser and the SSR render.
 *
 * It has to be here rather than in Layout: /admin/preview/ renders the site's
 * sections without Layout (ADR-0003), and it has to look like the page it is
 * previewing. wrapRootElement is the one seam both renders share, and keeping
 * it in the two Gatsby files together means the server and the browser cannot
 * disagree about which theme they mounted.
 */
exports.wrapRootElement = ({ element }) =>
  React.createElement(ThemeProvider, { theme }, element);
